import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Swal from 'sweetalert2';

const useHandleCloseModal = (modalRef: any, closeModalRef: any, formik: any, target: string = "", cb: () => void = () => { }, type: 'default' | 'termin' | 'invoice-add-log' = 'default') => {
    const intl = useIntl();

    const handleCloseModal = async (e: any) => {
        e.stopPropagation();
        e.preventDefault();

        const value = Object.entries(formik.values).filter(
            ([key, value]) => value != null && value !== "" && !(Array.isArray(value) && value.length === 0)
        );

        if (value.length > 0 && type !== 'invoice-add-log') {
            const result = await Swal.fire({
                title: intl.formatMessage({ id: type === 'termin' ? 'ALERT.TITLE.WARNING' : 'FORM.VALIDATION.CANCEL' }),
                text: intl.formatMessage({ id: type === 'termin' ? 'FORM.VALIDATION.DESC_CANCEL_TERMIN' : 'FORM.VALIDATION.DESC_CANCEL' }),
                icon: 'warning',
                showCancelButton: true,
                buttonsStyling: false,
                confirmButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.YES' }) + ", " + intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
                cancelButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.NO' }),
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-active-light me-3",
                },
                reverseButtons: true,
                heightAuto: false,
                target: document.getElementById(target),
            });

            if (result.isConfirmed) {
                try {
                    await cb(); // Tunggu eksekusi cb() selesai
                } catch (error) {
                    console.error("Error in callback function:", error);
                }
                closeModalRef.current?.click();
            }
        } else {
            try {
                await cb(); // Tunggu eksekusi cb() selesai
            } catch (error) {
                console.error("Error in callback function:", error);
            }
            closeModalRef.current?.click();
        }
    };

    const handleClickOutside = async (e: any) => {
        if (modalRef.current && modalRef.current === e.target) {
            e.stopPropagation();
            e.preventDefault();

            const value = Object.entries(formik.values).filter(
                ([key, value]) => value !== null && value !== ""
            );

            if (value.length > 0 && type !== 'invoice-add-log') {
                const result = await Swal.fire({
                    title: intl.formatMessage({ id: type === 'termin' ? 'ALERT.TITLE.WARNING' : 'FORM.VALIDATION.CANCEL' }),
                    text: intl.formatMessage({ id: type === 'termin' ? 'FORM.VALIDATION.DESC_CANCEL_TERMIN' : 'FORM.VALIDATION.DESC_CANCEL' }),
                    icon: 'warning',
                    showCancelButton: true,
                    buttonsStyling: false,
                    confirmButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.YES' }) + ", " + intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
                    cancelButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.NO' }),
                    customClass: {
                        confirmButton: "btn btn-danger",
                        cancelButton: "btn btn-active-light me-3",
                    },
                    reverseButtons: true,
                    heightAuto: false,
                });

                if (result.isConfirmed) {
                    try {
                        await cb();
                    } catch (error) {
                        console.error("Error in callback function:", error);
                    }
                    closeModalRef.current?.click();
                }
            } else {
                try {
                    await cb();
                } catch (error) {
                    console.error("Error in callback function:", error);
                }
                closeModalRef.current?.click();
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [formik]);


    useEffect(() => {
        const handleEscapeKey = async (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                handleClickOutside(e)
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation(); // Mencegah modal tertutup sebelum SweetAlert

            }
        };

        document.addEventListener("keydown", handleEscapeKey, true); // Gunakan `true` untuk menangani event di capture phase

        return () => {
            document.removeEventListener("keydown", handleEscapeKey, true);
        };
    }, [formik]);

    return { handleCloseModal };
};

export default useHandleCloseModal;